
(function () {
    var ParkingAreaCtrl = (function () {
        function ParkingAreaCtrl() {
            this.init.apply(this, arguments);
        }

        ParkingAreaCtrl.prototype = {
            init: function ($scope, $state, $q, $rootScope, $stateParams, 
                localStorageService, $mdDialog, $ionicPopup,  ChargeRequestService,
                vehiclestatus, useBooking, siteId, hasParkings, AuthService, $Loading, $translationService, $mdBottomSheet) {

                $scope.vm = this;
                this.$scope = $scope;
                this.$state = $state;
                this.$q = $q;
                this.$stateParams = $stateParams;
                this.localStorageService = localStorageService;
                this.$mdDialog = $mdDialog;
                this.chargeRequestService = ChargeRequestService;
                this.vehiclestatus = vehiclestatus;
                this.$ionicPopup = $ionicPopup;
                this.$translationService = $translationService;
                this.$mdBottomSheet = $mdBottomSheet;
                // this is the charge booking user want to use, this to detect that user can re-select charging point of the booking
                this.useBooking = useBooking;
                this.siteId = siteId;

                this.AuthService = AuthService;
                this.$Loading = $Loading;

                this.hasParkings = hasParkings;
                this.parkingId = null;

                this.isShowParkings = false; // for UI
                this.showBack = false;


                /** @type IChargingPoint[] */
                this.rows = [];

                var user = this.AuthService.getAuthenticatedUser();

                
                // NF-1305: hide report issue button for charging points on mobile when the flag is enabled for the user
                this.disableReportIssueForChargingPointsOnMobile = user.DisableReportIssueForChargingPointsOnMobile || false;

                this.site = user.Sites.find((site)=>{
                   return site.Id === siteId; 
                });

                if (this.hasParkings) {
                    this.isShowParkings = true; 
                    this.showParkings();
                } else {
                    this.isShowParkings = false;
                    this.showChargingPoints();
                }
                
            },
            chunk: function (arr, len) {
                var chunks = [],
                    i = 0,
                    n = arr.length;
                while (i < n) {
                    chunks.push(arr.slice(i, i += len));
                }
                return chunks;
            },
            selectParking: function (parking) {
                this.parkingId = parking.Id;

                this.showBack = true;
                this.showChargingPoints();
            },
            showParkings: function () {
                this.getParkings().then(angular.bind(this, function (list) {
                    this.rows = list;
                    this.isShowParkings = true;
                }));
            },
            showChargingPoints: function () {
                var self = this;
                this.$Loading.show();
                this.getChargingPoints().then(angular.bind(this, function (list) {                    
                    this.rows = this.chunk(list, 4);
                    this.isShowParkings = false;
                })).finally(function () {
                    self.$Loading.hide();
                });
            },
            getParkings: function () {
                return this.chargeRequestService.getParkings(this.siteId);
            },
            
            /**
             *
             * @returns {angular.IPromise<IChargingPoint[]>}
             */
            getChargingPoints: function () {
                return this.chargeRequestService.getChargingPoints(this.siteId, this.parkingId, true /*With external */);
            },
            // NF-1165: This is for report issue, we get all points of current site for all parkings
            getAllChargingPoints: function () {
                return this.chargeRequestService.getChargingPoints(this.siteId);
            },
            cancel: function () {
                if (this.showBack) {
                    this.isShowParkings = true;
                    this.showBack = false;
                    this.showParkings();
                } else {
                    this.$mdDialog.cancel();
                }
                
            },
            
            /**
             * Select a charge point call when click on charge point
             * @param {IChargingPoint} chargingPoint
             */
            selectChargingPoint: function (chargingPoint) {
                let self = this;

                // Use Usable to check can select point
                if (!chargingPoint.Usable) {
                    return;
                }

                var user = this.AuthService.getAuthenticatedUser();

                // if user using a charge booking and he re-select the charging point reserved for him then we allow to select directly
                if (user.UserId === chargingPoint.ChargeBookingDriverId && this.useBooking && this.useBooking.ChargingPointId === chargingPoint.ChargingPointId) {
                    this.$mdDialog.hide(chargingPoint);
                    return;
                }

                // Priority n°3 : Not accessible 
                // Show confirm when not accessible 
                if(chargingPoint.State === 3) {
                    this.showConfirmNotAccessible(chargingPoint).then((result)=> {
                        if(result) {
                            this.$mdDialog.hide(chargingPoint);
                        }
                    });
                    return;
                }
                
                // Priority n°6 : Reserved in more than X minutes
                // If later have been booked by other driver we need current driver to confirm that he will move the vehical
                if (chargingPoint.State === 6 ) { 
                    this.showConfirmSelectedBookedStation(chargingPoint).then(function(res) {
                        if(res) {
                            self.$mdDialog.hide(chargingPoint);
                        }
                    });

                    return;
                }
                this.$mdDialog.hide(chargingPoint);
            },
            showConfirmSelectedBookedStation: function (chargingPoint) {
                var title = this.$translationService.getTranslation('ReservedTitle');
                var msg = this.$translationService.formatTranslation('ReservedBody', chargingPoint.ChargingPointName, chargingPoint.ChargeBookingStartTime, chargingPoint.ChargeBookingDriverName);

                return this.$ionicPopup.confirm({
                    cssClass: 'reserved-confirm',
                    title: title,
                    template: msg,
                    buttons: [
                        {
                            text: this.$translationService.getTranslation('IAgree'),
                            type: 'button-positive',
                            onTap: function(e) {
                                // Returning a value will cause the promise to resolve with the given value.
                                return true;
                            }
                        },
                        {
                            text: this.$translationService.getTranslation('Cancel')
                        }
                    ]
                });
            },
            reportIssue(){
                this.getAllChargingPoints()
                .finally(this.$Loading.blockUI())
                .then((points) => {
                    let availablePoints = points.filter((p) => !p.NotAccessible && p.Usable);
                    this.$mdBottomSheet.show({
                        clickOutsideToClose: false,
                        escapeToClose: false,
                        isLockedOpen: true,
                        templateUrl: 'js/internal/parkingarea/report-issue/report-issue.html',
                        controller: 'ReportIssueController',
                        controllerAs: 'vm',
                        locals: {
                            canQueue: this.site.QueuedChargeRequestEnabled || false,
                            siteId: this.site.Id,
                            availableChargingPoints: availablePoints
                        }
                    }).then((result) => {
                        if (result === 'NoChargingPointAvailable') { // Close the parking area dialog, show queue charge request
                            this.$mdDialog.hide('NoChargingPointAvailable');
                        }
                        if (result === 'SpecificChargingPointIssue') { // Refresh the parking area to show the updated status
                            this.showChargingPoints();
                        }

                    });
                })
            },
            
            showConfirmNotAccessible(chargingPoint){
                var title = this.$translationService.getTranslation('confirmReActiveCharger');
                var msg = this.$translationService.formatTranslation('msgConfirmReActiveCharger', chargingPoint.ChargingPointName);

                return this.$ionicPopup.confirm({
                    cssClass: 'reserved-confirm button-normal',
                    title: title,
                    template: msg,
                    buttons: [
                        {
                            text: this.$translationService.getTranslation('confirmAndStartCharging'),
                            type: 'button-positive',
                            onTap: () => {
                                // Returning a value will cause the promise to resolve with the given value.
                                return true;
                            }
                        },
                        {
                            text: this.$translationService.getTranslation('Cancel')
                        }
                    ]
                });
            }
        };
        ParkingAreaCtrl.$inject = ['$scope', '$state', '$q', '$rootScope', '$stateParams', 'localStorageService', 
            '$mdDialog', '$ionicPopup', 'ChargeRequestService', 'vehiclestatus', 'useBooking', 'siteId', 'hasParkings', 'AuthService', '$Loading', '$translationService', '$mdBottomSheet'];
        return ParkingAreaCtrl;
    }());
    angular.module('internal.parkingarea').controller('ParkingAreaCtrl', ParkingAreaCtrl)
})();


